import { Base } from '../base-component';

import './form-container-wizard.component.scss';

export class FormContainerWizard extends Base {

	bulletContainer: Element;
	wizardContainer: Element;
	wizardStepsContainer: Element;

	customHeading: HTMLFormElement;

	// buttons
	stepButtons: Element[];
	backButton: Element[];

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
		this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
		this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
		this.customHeading = this.element.querySelector(".customHeading");
		// buttons
		this.stepButtons = Array.from(this.element.querySelectorAll(".js_next-step-button"));
		this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
		this.showStep(1);
	}

	bindEvents() {
		if (this.stepButtons.length) {
			this.stepButtons.map((item) => item.addEventListener('click', (event) => {
				const _event: any = event.currentTarget;
				const _currentStep = _event.closest(".form-container-wizard__steps--step");
				if (_currentStep && (!_currentStep.classList.contains(".form-container-wizard__steps--hidden"))) {
					const formFields: any = _currentStep.querySelectorAll('input, select, textarea');
					this.validationService.validate(formFields);
					const valid = Array.from(_currentStep.querySelectorAll(".form__group--error"));
					if (valid.length === 0) {
						this.showNextStep(event);
					}
				}
			}));
		}
		if (this.backButton.length) {
			this.backButton.map((item) => item.addEventListener('click', (event) => {
				this.showPreviousStep(event);
			}));
		}

		// Reset the form
		this.wizardContainer.addEventListener('custom_wizard_reset_event', (e) => {
			this.showStep(1);
		}, false);
	}

	showStep(stepId) {
		const showStep = parseFloat(stepId);
		if (this.bulletContainer) {
			const _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet")) as HTMLFormElement[];
			_bullets.map((pItem: any) => {
				const displayStep = parseFloat(pItem.getAttribute("data-step"));
				if (displayStep <= showStep) {
					pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
				}
				else {
					pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
				}
			});
		}

		const _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
		let _heading: any = '';
		_steps.map((pStep: any) => {
			const _step = parseFloat(pStep.getAttribute("data-step"));
			if (_step == showStep) {
				_heading = pStep.getAttribute("data-heading");
				pStep.classList.remove("form-container-wizard__steps--hidden");
			} else {
				pStep.classList.add("form-container-wizard__steps--hidden");
			}
		});
		const _h3Heading = this.customHeading.querySelector("h3");
		if (_heading != '') {
			_h3Heading.innerHTML = _heading;
		} else {
			_h3Heading.innerHTML = '';
		}
	}

	showNextStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		this.showStep(parseFloat(_nextStep));
	}

	showPreviousStep(event) {
		const _target = event.currentTarget;
		const _currentStep = _target.closest("[data-step]");
		const _nextStep = _currentStep.getAttribute("data-step");
		this.showStep(parseFloat(_nextStep));
	}
}



// WEBPACK FOOTER //
// ./components/form-container-wizard/form-container-wizard.component.ts